<template>
    <div style="overflow:auto;width:fit-content;margin:auto;direction:ltr;">
        <v-layout class="mx-1" justify-center align-center v-for="row in config.rows" :key="row">
            <div class="seat-container" v-for="col in config.cols" :key="col" >
                <div v-tooltip="{
                    content: _seatTooltipContent(_seatId(row,col)),
                    placement: 'top-center',
                    classes: ['org-theme'],
                    targetClasses: ['it-has-a-tooltip'],
                    offset:0,
                    delay:{ show: 500, hide: 100 },
                    }"
                    v-if="_isSeatAccessible(_seatId(row,col))"
                    :class="_classifier(_seatId(row,col))" class="text-xs-center" @click.stop="onSeatSelected(_seatId(row,col))">
                    <div>{{_seatLabel(_seatId(row,col))}}</div>
                    <SeatSVG :width="'30px'" :classifier="_classifier(_seatId(row,col))"></SeatSVG>
                </div>
                <!-- Blank space / Aisle-->
                <div v-else style="margin:14px"></div>
            </div>
        </v-layout>
    </div>
</template>

<script>
import SeatSVG from "@/components/SeatSVG"
import {seatMethods,seatCategoryMethods} from "@/mixins/seats"
import { currencySymbol } from "@/mixins/currencySymbol";
import { mapState } from "vuex";

export default {
    name:"SeatsChart",
    props:{
        config:{
            type:Object,
            default:{}
        },
        seats:{
            type:Object,
            default:{}
        },
        reservedSeats:{
            type:Array,
            default:[]
        },
        seatsStatus:{
            type:Object,
            default:{}
        },
        selectedSeats:{
            type:Array,
            default:[]
        },
        seatPricing:{
            type:Object,
            default:{}
        },
        lockedSeatsByUser:{
            type:Array,
            default:[]
        }
    },
    components:{
        SeatSVG
    },
    mixins:[seatMethods,seatCategoryMethods,currencySymbol],
    computed:{
        ...mapState({
            company: (state) => state.company.company,
        }),
    },
    methods:{
        /** Returns suitable class according to status/category @return String */
        _classifier(seatId){
            if(!this._isSeatExists(seatId)){
               return;
            }

            switch(this._seatStatus(seatId)) {
                case this.DEFINES.SEATS_STATUS.AVAILABLE:
                    return this._handleSeatAvailableStatus(seatId);
                case this.DEFINES.SEATS_STATUS.LOCKED:
                    return this._handleSeatLockedStatus(seatId);
                case this.DEFINES.SEATS_STATUS.BOOKED:
                    return this.DEFINES.SEATS_STATUS_CLASSES.BOOKED;
                default:
                    return this.DEFINES.SEATS_STATUS_CLASSES.AVAILABLE;
            }
        },
        /** Manages Available status with suitable category */
        _handleSeatAvailableStatus(seatId){
            if(this._isSeatSelected(seatId)){
                return this.DEFINES.SEATS_STATUS_CLASSES.SELECTED;
            }
            /** If seat not selected, apply suitable category if availble on seat */
            let category = this._categoryClassifier(this._seatCategory(seatId));
            return category.colorClass;
        },
        _handleSeatLockedStatus(seatId){
            /** Seat locked but might be that locked by the current logged in user */
            if(this._isLockedByLoggedInUser(seatId)){
                return this._handleSeatAvailableStatus(seatId);
            }
            return this.DEFINES.SEATS_STATUS_CLASSES.LOCKED;
        },
         /** Prepare & returns HTML string @return String */
        _seatTooltipContent(seatId){
            let seatLabel = this._seatLabel(seatId);
            let seatCategory = this._categoryClassifier(this._seatCategory(seatId));
            let seatPrice = this.getCurrencySymbol(this.company.currency)+this._seatPrice(seatId);

            return this.$t("screener.seats.label.title")+" : <b>"+seatLabel+"</b><br/>"+this.$t("screener.seats.category.title")+" : <b>"+this.$t(seatCategory.label)+"</b><br/>"+this.$t("screener.seats.price.title")+" : <b>"+seatPrice+"</b>";
        },
        onSeatSelected(seatId){
            this.$emit("onSeatSelected",seatId);
        },
        /** Tells that selected seat was locked by the same logged in user @returns Boolean */
        _isLockedByLoggedInUser(seatId){
            return this.lockedSeatsByUser.find (lockedSeatId => {
                return lockedSeatId == seatId;
            });
        }
    }
}
</script>

<style scoped>
.seat-container{
    padding:2.5px;
    min-width: 2%;
    font-size: smaller;
}
</style>
